export const PARTNER_PORTAL_BASE = '/partner-portal';
export const PARTNER_PORTAL_HOME = PARTNER_PORTAL_BASE;
export const PARTNER_PORTAL_SUBMIT = `${PARTNER_PORTAL_BASE}/submit`;
export const PARTNER_PORTAL_MY_PROJECTS = `${PARTNER_PORTAL_BASE}/my-projects`;
export const PARTNER_PORTAL_PROJECT_DETAIL_BASE = `${PARTNER_PORTAL_BASE}/project-detail`;
export const PARTNER_PORTAL_PROJECT_DETAILS = `${PARTNER_PORTAL_PROJECT_DETAIL_BASE}/:id`;
export const PARTNER_PORTAL_PAE_QUEUE = `${PARTNER_PORTAL_BASE}/pae/project-queue`;
export const PARTNER_PORTAL_PAE_PROJECT_DETAIL_BASE = `${PARTNER_PORTAL_BASE}/pae/project-detail`;
export const PARTNER_PORTAL_PAE_PROJECT_DETAIL_PATH = `${PARTNER_PORTAL_PAE_PROJECT_DETAIL_BASE}/:id`;
export const PARTNER_PORTAL_PAE_PROJECT_BASE = `${PARTNER_PORTAL_BASE}/pae/project`;
export const PARTNER_PORTAL_PAE_PROJECT_DETAILS = `${PARTNER_PORTAL_PAE_PROJECT_BASE}/:id`;
export const PARTNER_PORTAL_PARTNER_COMPANIES = `${PARTNER_PORTAL_BASE}/pae/partner-companies`;
export const PARTNER_PORTAL_PAE_OPERATIONS = `${PARTNER_PORTAL_BASE}/pae/operations`;
export const PARTNER_PORTAL_LEADERSHIP_PIPELINE = `${PARTNER_PORTAL_BASE}/leadership/pipeline`;
export const PARTNER_PORTAL_NOT_AUTHORIZED = `${PARTNER_PORTAL_BASE}/not-authorized`;

export const buildPaeQueueProjectUrl = (projectId) => {
  const id = String(projectId || '').trim();
  if (!id) {
    return PARTNER_PORTAL_PAE_QUEUE;
  }
  return `${PARTNER_PORTAL_PAE_QUEUE}?${new URLSearchParams({ project: id }).toString()}`;
};
